export default "__VITE_ASSET__BBCxEnhX__"